



































import { Vue, Watch, Component, Prop } from "vue-property-decorator";
import { LayoutStyle } from "@/types";

@Component
export default class AppBar extends Vue {
  @Prop({ default: undefined }) specialLayout: LayoutStyle | undefined;

  public changeLanguage(lang: string): void {
    if (this.$route.params.lang !== lang) {
      this.$router.push({
        path: this.$route.path.replace(/(\/[^/]*)(.*)/, `/${lang}$2`),
      });
    }
  }

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange() {
    const body = document.getElementsByTagName("body")[0];
    if (this.specialLayout !== undefined) {
      body.className = this.specialLayout;
    } else {
      body.className = LayoutStyle.Default;
    }
  }
}
